export function sanitize(input: string): string {
  // Define a regex to match zero-width characters
  const zeroWidthRegex = /[\u200B\u200C\u200D\uFEFF]/g;
  // Replace zero-width characters with an empty string
  return input.replace(zeroWidthRegex, "");
}
